import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { TYPOGRAPHY_COLOR } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline',
    backgroundColor: TYPOGRAPHY_COLOR,
    color: '#FFFFFF',
    padding: theme.spacing(0.5),
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(16),
  },
}));

const ContentTitle = ({ children, ...other }) => {
  const classes = useStyles();
  return (
    <Typography className={classes.root} {...other}>
      {children}
    </Typography>
  );
};

export default ContentTitle;
